(function($) {
  'use strict';

  const animations = {
    dom: function() {
      this.$banner = $('.page-banner');
      this.$bannerContent = $('.page-banner__column--content');
      this.$bannerMedia = $('.page-banner__image, .page-banner__video');
      this.$logos = $('.logos__cards');
      this.$processCards = $('.process__cards');
      this.$scrollSlider = $('[data-scroll-slider]');
      this.$section = $('.section');
      this.$sectionImageAsset = $('.section__media');
      this.$slideIn = $('[data-slide-in]');
      this.$stickyImage = $('.js-stick-image');
    },

    banner: function() {
      const _ = this;

      gsap.to(_.$bannerContent, {
        scrollTrigger: {
          trigger: _.$banner,
          start: 'top top',
          end: 'bottom top',
          toggleActions: 'restart none reverse reset',
          scrub: true
        },
        y: '-=10%'
      });

      gsap.to(_.$bannerMedia, {
        scrollTrigger: {
          trigger: _.$banner,
          start: 'top top',
          end: 'bottom top',
          toggleActions: 'restart none reverse reset',
          scrub: true
        },
        y: '10%'
      });
    },

    logos: function() {
      let offset = 14;

      this.$logos.each(function() {
        const $this = $(this);
        const $row = $this.find('.logos__cards-row');
        let directionLeft = true;
        $row.each(function() {
          const $rowItem = $(this);
          gsap.to($rowItem, {
            scrollTrigger: {
              trigger: $rowItem,
              start: 'top bottom',
              end: 'bottom top-=' + offset + 'vw',
              toggleActions: 'restart none reverse reset',
              scrub: true
            },
            ease: 'linear',
            x: directionLeft ? '-' + offset + 'vw' : offset + 'vw'
          });
          directionLeft = !directionLeft;
        });
      });
    },

    process: function() {
      this.$processCards.each(function() {
        const $this = $(this);
        const $card = $this.find('.process__card');
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: $this,
            start: 'top bottom-=10%',
            end: 'center top',
            toggleActions: "restart none reverse reset",
            scrub: true
          }
        });
        $card.each(function() {
          tl.to($card, {opacity: 1, transform: 'translateX(0)'});
        });
      });
    },

    scrollSlider: function() {
      const _ = this;
      _.$scrollSlider.each(function() {
        const $this = $(this);
        gsap.to($this, {
          scrollTrigger: {
            trigger: $this,
            start: 'top bottom+=50',
            end: 'bottom top-=50',
            toggleActions: "restart none reverse reset",
            scrub: true
          },
          x: '-=10%'
        });
      });
    },

    sectionZoom: function() {
      const _ = this;
      _.$sectionImageAsset.each(function() {
        const $this = $(this);
        const $trigger = $this.closest('.section__media-wrap');
        gsap.to($this, {
          scrollTrigger: {
            trigger: $trigger,
            start: 'top top',
            end: 'bottom top',
            toggleActions: "restart none reverse reset",
            scrub: true,
            pin: true
          },
          scale: 1
        });
      });
    },

    slideIn: function() {
      const _ = this;

      _.$slideIn.each(function() {
        const $this = $(this);
        let $target = $this.data('slide-in') === 'children' ? $this.children() : $this;
        $target.each(function() {
          const $element = $(this);
          gsap.fromTo($element, {
            y: '10%',
            opacity: 0
          }, {
            scrollTrigger: {
              trigger: $element,
              start: 'top bottom',
              end: 'top center',
              toggleActions: 'restart none reverse reset',
              scrub: true
            },
            y: '0%',
            opacity: 1
          });
        });
      });
    },

    stickyImage: function() {
      this.$stickyImage.each(function() {
        const $parent = $(this);
        const $image = $parent.children();
        $parent.parent().css({
          'clip-path': 'polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)'
        });
        $image.css('transform', 'scale(1.2)');
        gsap.to($image, {
          scrollTrigger: {
            trigger: $parent,
            start: 'top top',
            end: 'bottom top',
            toggleActions: "restart none reverse reset",
            scrub: true,
            pin: true
          },
          scale: 1
        });
      });
    },

    sectionEntry: function() {
      const title = new SplitType('.js-section-title');

      $('.js-section-title').each(function() {
        const $this = $(this);
        const $elems = $this.find('.char');
        gsap.fromTo($elems, {
          y: '100%',
          opacity: 0
        }, {
          scrollTrigger: {
            trigger: $this,
            start: 'top bottom-=50',
            end: 'bottom center',
            // toggleActions: 'restart none reverse reset',
            // scrub: true,
            markers: true
          },
          y: 0,
          opacity: 1,
          stagger: 0.02,
          // delay: 0.2,
          duration: .01
        });
      });
    },

    ready: function() {
      this.dom();
      this.banner();
      this.logos();
      this.process();
      this.scrollSlider();
      this.sectionZoom();
      this.slideIn();
      this.stickyImage();
      // this.sectionEntry();
    }
  };

  $(function() { animations.ready(); });

})(jQuery);
